angular.module("siter.io").controller "HtmlOfFormController", ["$scope", "$rootScope", "$modalInstance", "SectionWebForm", "Translit", "$state", "$timeout", ($scope, $rootScope, $modalInstance, SectionWebForm, Translit, $state, $timeout) ->

  focusText = ($element) ->
    $element.focus () ->
      $element.select();
      # Work around Chrome little problem
      $element.mouseup () ->
        # Prevent further mouseup intervention
        $element.unbind("mouseup");
        return false;

  # javascript code
  containerId = 'form-' + $rootScope.currentSite.id;
  $scope.htmlLoader = '<script id="' + containerId + '" type="text/javascript" src="' + $rootScope.justclick.apiURL + '/web_forms/' + $rootScope.currentSite.id + '/form_loader.js?cid=' + containerId + '"></script>';
  $scope.currentTab = 'htmlLoader';
  $scope.showExamples = false;

  $timeout ->
    focusText $('#loader_of_form')
  , 300


  # html code
  SectionWebForm.getHtmlCodeOfForm($rootScope.currentSite.id).then (htmlCode) ->
    SectionWebForm.getStylesheetsOfForm($rootScope.currentSite.id).then (stylesheets) ->
      cssCode = '<style type="text/css">' + stylesheets + '</style>'
      jsCode = '<script type="text/javascript" charset="UTF-8" src="' + $rootScope.originHost + '/constructor/editor/scripts/common-forms.js' + '"></script>';

      $scope.htmlData = cssCode + htmlCode + jsCode;

      focusText $('#html_of_form')
    , ->
      $modalInstance.dismiss "close"
    , 300
  , ->
    $modalInstance.dismiss "close"
  , 300
]



// WEBPACK FOOTER //
// ./src/app/webform/html_of_form.controller.coffee